import { render, staticRenderFns } from "./type.vue?vue&type=template&id=1b33ba2e&scoped=true&"
import script from "./type.vue?vue&type=script&lang=js&"
export * from "./type.vue?vue&type=script&lang=js&"
import style0 from "./type.vue?vue&type=style&index=0&id=1b33ba2e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b33ba2e",
  null
  
)

export default component.exports